<template>
  <div class="mod-config">
    <el-table :data="dataList"
              border
              v-loading="dataListLoading"
              @selection-change="selectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="selection"
                       header-align="center"
                       align="center"
                       width="50">
      </el-table-column>
      <el-table-column prop="id"
                       header-align="center"
                       align="center"
                       label="id">
      </el-table-column>
      <el-table-column prop="gsname"
                       header-align="center"
                       align="center"
                       label="公司名称">
      </el-table-column>
      <el-table-column prop="phone"
                       header-align="center"
                       align="center"
                       label="电话">
      </el-table-column>
      <el-table-column prop="fuzeren"
                       header-align="center"
                       align="center"
                       label="负责人">
      </el-table-column>
      <el-table-column prop="diqu"
                       header-align="center"
                       align="center"
                       label="地区">
      </el-table-column>
      <el-table-column prop="zhizhaoimg"
                       header-align="center"
                       align="center"
                       label="执照图片">
        <template slot-scope="scope2">
          <img :src="scope2.row.zhizhaoimg"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="status"
                       header-align="center"
                       align="center"
                       label="状态">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.status===0"
                  type="error">未通过</el-tag>
          <el-tag v-if="scope2.row.status===1"
                  type="success">通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createtime"
                       header-align="center"
                       align="center"
                       label="提交时间">
      </el-table-column>
      <el-table-column fixed="right"
                       header-align="center"
                       align="center"
                       width="150"
                       label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status==0"
                     type="text"
                     size="small"
                     @click="shenhetongguo(scope.row.id)">通过</el-button>
          <el-button type="text"
                     size="small"
                     @click="delshenqing(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination> -->
    <!-- 弹窗, 新增 / 修改 -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {

  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 删除申请
    delshenqing (id) {
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgshening/delete',
        method: 'get',
        params: {
          'id': id
        }
      }).then((data) => {
        data = data.body
        this.getDataList()
        this.dataListLoading = false
      })
    },
    // 审核通过
    shenhetongguo (id) {
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgshening/shenqingtongguo',
        method: 'get',
        params: {
          'id': id
        }
      }).then((data) => {
        data = data.body
        this.getDataList()
        this.dataListLoading = false
      })
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgshening/getalllist',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'key': this.dataForm.key
        }
      }).then((data) => {
        data = data.data
        if (data.length!= 0) {
          this.dataList = data
        } else {
          this.dataList = []
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/jxjg/jgshening/delete',
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/jgshening.vue